export default __webpack_public_path__ + "static/media/dg-dropdown.9e980956.webp";